import { Link } from "react-router-dom";
import { api, lim } from "../lib/api";
import { PageHeader, Stat, useLoad, StatusBadge, Meter } from "../components/common";

export default function AdminDashboard() {
  const [d] = useLoad(async () => (await api.get("/dashboard")).data);
  const [teams] = useLoad(async () => (await api.get("/teams")).data);
  return (
    <div data-testid="admin-dashboard">
      <PageHeader title="Organization" sub={d ? `Business day ${d.today} · ${d.timezone}` : ""}>
        {d?.global_pause && <StatusBadge s="rejected" label="Global pause ON" testid="global-pause-badge" />}
      </PageHeader>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 mb-8">
        <Stat label="Master leads" value={d?.leads_total} testid="stat-leads-total" />
        <Stat label="Available pool" value={d?.available} testid="stat-available" />
        <Stat label="With teams" value={d?.team_allocated} testid="stat-team-allocated" />
        <Stat label="With reps" value={d?.assigned} testid="stat-assigned" />
        <Stat label="Funded" value={d?.funded} tone="text-emerald-700" testid="stat-funded" />
        <Stat label="Expiring 24h" value={d?.expiring_24h} tone="text-amber-600" testid="stat-expiring" />
        <Stat label="Staff records" value={d?.users} testid="stat-users" />
        <Stat label="Teams" value={d?.teams} testid="stat-teams" />
        <Stat label="Open review items" value={d?.open_review} tone="text-amber-600" testid="stat-review" />
        <Stat label="Pending rep requests" value={d?.pending_requests} testid="stat-pending" />
        <Stat label="Extra-lead requests to approve" value={d?.pending_extra} tone="text-amber-600" testid="stat-pending-extra" />
        <Stat label="Imports running" value={d?.imports_running} testid="stat-imports" />
        <Stat label="Suppressed" value={d?.suppressed} testid="stat-suppressed" />
      </div>
      <h2 className="text-lg font-bold mb-3">Teams today</h2>
      <div className="panel overflow-x-auto">
        <table className="dt" data-testid="dashboard-teams-table">
          <thead><tr><th>Team</th><th>Leader</th><th className="num">Members</th><th className="w-64">Lead allowance (team)</th><th>Mode</th><th className="num">Allocations today</th></tr></thead>
          <tbody>{(teams || []).map((t) => (
            <tr key={t.id}><td className="font-medium"><Link to="/teams" className="hover:underline">{t.name}</Link></td><td>{t.leader?.display_name || "—"}</td>
              <td className="num">{t.member_count}</td>
              <td><Meter label="" allowance={t.capacity.allowance} used={t.capacity.used} testid={`dash-team-meter-${t.id}`} /></td>
              <td className="text-xs">{t.capacity.mode === "manual" ? `Shared ceiling ${lim(t.capacity.manual_ceiling)}` : `Sum of ${t.capacity.eligible_count} eligible`}</td>
              <td className="num">{t.today_allocations}</td></tr>))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
